export type NavSectionId = 'storage' | 'locations' | 'faq';

export const HOME_NAV_SECTIONS: Array<{
  id: NavSectionId;
  label: string;
  href: string;
  external: boolean;
}> = [
  { id: 'storage', label: 'How it works', href: '#storage', external: false },
  { id: 'locations', label: 'Locations', href: '#locations', external: false },
  {
    id: 'faq',
    label: 'Help center',
    href: '/help',
    external: true,
  },
];

/** DOM ids per nav item — active while scrolled past the first target */
export const NAV_SECTION_TARGETS: Record<NavSectionId, string[]> = {
  storage: ['storage', 'security', 'comparison'],
  locations: ['locations'],
  faq: ['faq'],
};

export const NAV_SECTION_ORDER: NavSectionId[] = [
  'storage',
  'locations',
  'faq',
];
